import { Country, State } from "country-state-city";

const countries = Country.getAllCountries();

export const getAllCountries = () => {
  return countries
    .map((country) => ({
      value: country.name,
    }))
    .sort((a, b) => a.value.localeCompare(b.value));
};

// Same list, but with Nigeria pinned to the top (matches previous UX)
export const getCountriesWithNigeriaFirst = () => {
  const temp = getAllCountries();
  const nigeria = temp.find((c) => c.value.toLowerCase() === "nigeria");

  return [
    ...(nigeria ? [nigeria] : []),
    ...temp.filter((c) => c.value.toLowerCase() !== "nigeria"),
  ];
};

export const getCountryByName = (name?: string) => {
  if (!name) return undefined;
  return countries.find((c) => c.name.toLowerCase() === name.toLowerCase());
};

// ISO alpha-2 code, e.g. "NG" — also used (lowercased) for the phone input flag
export const getCountryCodeByName = (name?: string) => {
  return getCountryByName(name)?.isoCode;
};

export const getStateCodeByName = (countryCode?: string, stateName?: string) => {
  if (!countryCode || !stateName) return undefined;
  return State.getStatesOfCountry(countryCode).find(
    (s) => s.name.toLowerCase() === stateName.toLowerCase()
  )?.isoCode;
};
